var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { BarDirectionItem } from './bar-direction-item';
import { BarDirectionType } from './bar-direction-type';
import { LocalizationHelper } from '../../../../../shared/helpers/localization-helper';
import { AppConsts } from '../../../../../shared/AppConsts';
var BarDirectionService = /** @class */ (function () {
    function BarDirectionService(localizationService) {
        this.localizationService = localizationService;
        this.barDirectionList = [
            new BarDirectionItem(BarDirectionType.DownToUp, this.l('DirectionDownToUp')),
            new BarDirectionItem(BarDirectionType.UpToDown, this.l('DirectionUpToDown')),
            new BarDirectionItem(BarDirectionType.LeftToRight, this.l('DirectionLeftToRight')),
            new BarDirectionItem(BarDirectionType.RightToLeft, this.l('DirectionRightToLeft'))
        ];
    }
    BarDirectionService.prototype.getBarDirection = function () {
        return this.barDirectionList;
    };
    BarDirectionService.prototype.l = function (value) {
        return LocalizationHelper.l(this.localizationService, AppConsts.localization.configureLocalizationSourceName, value);
    };
    BarDirectionService = __decorate([
        Injectable()
    ], BarDirectionService);
    return BarDirectionService;
}());
export { BarDirectionService };
